module.exports = __webpack_public_path__ + "static/media/avaya.82d25436.jpeg";